import axios from "axios";

import getEnvParam from "./getEnvParam";

const instance = axios.create({
	baseURL: getEnvParam("REACT_APP_BFF_URL_GRAPHQL"),
	timeout: 1000 * 1200,
	headers: {
		"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Method": "*",
		"Access-Control-Allow-Header": "*"
	}
})

/**
 * Request interceptor
 */
instance.interceptors.request.use(
	// get the token to pass in the header

);

/**
 * Response interceptor
 */
instance.interceptors.response.use(
	response => response,
	error => {
		return Promise.reject(error.response);
	}
);

export default instance;
